import { render, staticRenderFns } from "./paymentAdvance.vue?vue&type=template&id=60ba527d&scoped=true"
import script from "./paymentAdvance.vue?vue&type=script&lang=js"
export * from "./paymentAdvance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ba527d",
  null
  
)

export default component.exports